import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../styles/Login.css';

const Login_Anand = () => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [userCode, setUserCode] = useState('');
     const [password, setPassword] = useState('');
     const [error, setError] = useState('');
     const [loading, setLoading] = useState(false);
     const navigate = useNavigate();

     const location = useLocation();
     const params = new URLSearchParams(location.search);
     const urlToken = params.get('token');

     if (urlToken) {
          // send to backend to verify , call api 
          const verifyToken = async () => {
               try {
                    const res = await fetch(`${baseUrl}/verify-token`, {
                         method: 'POST',
                         headers: {
                              'Content-Type': 'application/json',
                         },
                         body: JSON.stringify({ token: urlToken }),
                    });

                    const data = await res.json();

                    if (data.status) {
                         // Store token in sessionStorage instead of localStorage
                         sessionStorage.setItem('token', data.token);
                         sessionStorage.setItem('user_code', data.user_code);
                         sessionStorage.setItem('user_name', data.user_name);
                         sessionStorage.setItem('user_role', data.role);

                         const expiryTime = new Date().getTime() + 4 * 60 * 60 * 1000;
                         sessionStorage.setItem('expiry', expiryTime);

                         // Auto-logout after 4 hours
                         setTimeout(() => {
                              sessionStorage.removeItem('token');
                              sessionStorage.removeItem('user_code');
                              sessionStorage.removeItem('user_name');
                              sessionStorage.removeItem('expiry');
                              sessionStorage.removeItem('user_role');
                              navigate('/login');
                         }, 4 * 60 * 60 * 1000);



                         if (data.password === 'default_password') {
                              navigate('/changepassword');
                         } else {
                              navigate('/dashboard');
                         }

                         // Redirect to dashboard
                         //  navigate('/dashboard');
                    } else {
                         setError(data.message || 'Token verification failed');
                    }
               } catch (err) {
                    setError('Something went wrong. Please try again.');
               }
          };

          verifyToken();
     }

     const handleSubmit = async e => {
          e.preventDefault();
          setError('');
          setLoading(true);

          try {
               const res = await fetch(
                    // `${baseUrl}/login`,
                    `${baseUrl}/newLogin`,
                    {
                         method: 'POST',
                         headers: {
                              'Content-Type': 'application/json',
                         },
                         body: JSON.stringify({
                              user_code: userCode,
                              password: password,
                         }),
                    }
               );

               const data = await res.json();

               if (data.status) {
                    // Store token in sessionStorage instead of localStorage
                    sessionStorage.setItem('token', data.token);
                    sessionStorage.setItem('user_code', data.user_code);
                    sessionStorage.setItem('user_name', data.user_name);
                    sessionStorage.setItem('user_role', data.role);

                    const expiryTime = new Date().getTime() + 4 * 60 * 60 * 1000;
                    sessionStorage.setItem('expiry', expiryTime);

                    // Auto-logout after 4 hours
                    setTimeout(() => {
                         sessionStorage.removeItem('token');
                         sessionStorage.removeItem('user_code');
                         sessionStorage.removeItem('user_name');
                         sessionStorage.removeItem('expiry');
                         sessionStorage.removeItem('user_role');
                         navigate('/login');
                    }, 4 * 60 * 60 * 1000);



                    if (data.password === 'default_password') {

                         navigate('/changepassword');
                    } else {
                         navigate('/dashboard');
                    }

                    // Redirect to dashboard
                    //  navigate('/dashboard');
               } else {
                    setError(data.message || 'Login failed');
               }
          } catch (err) {
               setError('Something went wrong. Please try again.');
          } finally {
               setLoading(false);
          }
     };

     return (
          <div className="login-page">
               <Container fluid className="h-100">
                    <Row className="h-100">
                         <Col md={7} className="login-illustration">
                              <div className="illustration-content">
                                   {/* <h2>Welcome to HRMS</h2> */}
                                   <img
                                        src="/login_internalhrms.jpg"
                                        alt="HR illustration"
                                        className="illust-image"
                                        style={{ width: "100%", borderRadius: "50px" }}
                                   />
                              </div>
                         </Col>
                         <Col md={5} className="login-form-side">
                              <div className="form-container">
                                   <h3 className="brand-title">HRMS</h3>
                                   <Form onSubmit={handleSubmit}>
                                        {error && <div className="text-danger mb-2">{error}</div>}
                                        <Form.Floating className="mb-3">
                                             <Form.Control
                                                  id="floatingUserCode"
                                                  type="text"
                                                  placeholder=" "
                                                  value={userCode}
                                                  onChange={e => setUserCode(e.target.value)}
                                                  autoComplete="off"
                                             />
                                             <label htmlFor="floatingUserCode">User Code</label>
                                        </Form.Floating>
                                        <Form.Floating className="mb-4">
                                             <Form.Control
                                                  id="floatingPassword"
                                                  type="password"
                                                  placeholder=" "
                                                  value={password}
                                                  onChange={e => setPassword(e.target.value)}
                                                  autoComplete="off"
                                             />
                                             <label htmlFor="floatingPassword">Password</label>
                                        </Form.Floating>
                                        <Button
                                             variant="dark"
                                             type="submit"
                                             className="w-100 mb-3"
                                             disabled={loading}
                                        >
                                             {loading ? 'Logging in...' : 'Login'}
                                        </Button>
                                        <div className="text-center">
                                             <a href="#forgot" className="forgot-link">
                                                  Forgot password?
                                             </a>
                                        </div>
                                   </Form>
                              </div>
                         </Col>
                    </Row>
               </Container>
          </div>
     );
};

export default Login_Anand;
